import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  MenuSeparator,
} from "@headlessui/react";

import { BillingSvg, ProfileSvg, SignOutSvg, TransactionIconSvg } from "./svg";
import { signOut } from "../../services/auth/auth.service";
import { useAppStore } from "../../store/store";
import { Link } from "react-router-dom";
import { ProtectedRoutes } from "../../types/Routes";

function ProfileDropDown() {
  const userData = useAppStore((state) => state.userData);
  const userDataIsLoading = useAppStore((state) => state.userDataIsLoading);

  const isLoading = userDataIsLoading && !userData;
  return (
    <Menu>
      <MenuButton>
        <div className="h-full flex gap-[12px] items-center cursor-pointer">
          {isLoading ? (
            <div className="sk_bg w-[32px] h-[32px] rounded-full "></div>
          ) : (
            <img
              src={userData.avatar || "/default.png"}
              alt="profile"
              className="w-[32px] h-[32px] rounded-full shadow"
            />
          )}

          <div className="flex flex-col justify-center max-md:hidden">
            {isLoading ? (
              <div className="sk_bg w-[150px] h-[13px] mb-2 "></div>
            ) : (
              <p className="text-[14px] 2xl:text-[16px] font-[500]  w-[150px] truncate text-left">
                {userData?.fullName}
              </p>
            )}
            {isLoading ? (
              <div className="sk_bg w-[150px] h-[13px]"></div>
            ) : (
              <p className="text-[12px] 2xl:text-[14px] font-[400] text-[#475467] w-[150px] truncate ">
                {userData?.email}
              </p>
            )}
          </div>
        </div>
      </MenuButton>
      <MenuItems
        transition
        anchor="bottom end"
        className="w-[200px] !shadow-md mt-2 rounded-md absolute z-50 bg-white origin-top transition duration-200 ease-out data-[closed]:scale-95 data-[closed]:opacity-0 pb-2 [--anchor-gap:7px]"
      >
        <MenuItem>
          <Link
            to={ProtectedRoutes.PROFILE}
            className="!py-2 rounded-[4px] text-[14px] 2xl:text-[16px] Nunito !font-[300] block transition cursor-pointer px-2 mx-2  hover:!bg-gray-100"
          >
            <div className="flex items-center gap-2">
              <ProfileSvg className="" />
              My Profile
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={ProtectedRoutes.TRANSACTIONS}
            className="!py-2 rounded-[4px] text-[14px] 2xl:text-[16px] Nunito !font-[300] block px-2 transition cursor-pointer mx-2  hover:!bg-gray-100"
          >
            <div className="flex items-center gap-2">
              <TransactionIconSvg className="w-[18px] h-[18px]" />
              Transactions
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={ProtectedRoutes.BILLING}
            className="!py-2 rounded-[4px] text-[14px] 2xl:text-[16px] Nunito !font-[300] block px-2 transition cursor-pointer mx-2  hover:!bg-gray-100"
          >
            <div className="flex items-center gap-2">
              <BillingSvg className="" />
              Billing
            </div>
          </Link>
        </MenuItem>
        <MenuSeparator className="h-px mx-2 my-1 bg-gray-200" />
        <MenuItem>
          <div className="!py-2 rounded-[4px] text-[14px] 2xl:text-[16px] Nunito !font-[300] block px-2 transition cursor-pointer mx-2 hover:!bg-gray-100 hover:!text-brand-darkYellow">
            <div
              className="flex gap-2 items-center !text-brand-red"
              onClick={signOut}
            >
              <SignOutSvg className="" />
              Sign Out
            </div>
          </div>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
}

export default ProfileDropDown;
